// extracted by mini-css-extract-plugin
export default {"wrapper":"BP-z","availablePromoMessagesLabel":"CP-z","promoMessageList":"DP-z","promoMessage":"EP-z","appliedPromoMessage":"FP-z","promoMessageAmount":"GP-z"};